module.exports = __webpack_public_path__ + "static/media/Cairo-Light.217c7577.woff";